require('@/service/service_autoatendimento/urljson')
import axios from 'axios'

async function httpsrc(){

  let  url = localStorage.getItem('APIAdaptor')
  let httpnova = axios.create({
    baseURL:url
  })
  httpnova.defaults.headers.modulo = 4
  httpnova.defaults.headers.common['Accept'] = 'application/json'
  return httpnova
} 

// CHAMDAS AXIOS
async function get (url) {
  let ht = await httpsrc() 
  return  ht.get(url);
}
async function post (url, params) {
  let ht = await httpsrc() 
  return  ht.post(url, params)
}
async function put (url, params) {
    let ht = await httpsrc() 
    return ht.put(url, params)
}
async function del (url, parms) {
  let ht = await httpsrc() 
  return ht.delete(url, parms)
}
async function patch (url, params) {
  let ht = await httpsrc() 
  return ht.patch(url, params)
}
// Export
export default {
    get, post, put, del, patch
}